import { getAccessToken, getProfile, getShopDomain, setShopDomain, setShopSettings } from '@/utils/auth.js'

import _find from 'lodash/find'
import axios from 'axios'
import Velocity from 'velocity-animate'

export const globals = {
  methods: {
    fixTargetBlankAttacks () { // Fix _blank target vulnerability
      let elements = document.querySelectorAll('a[target=_blank]')
      var rel

      for (let element of elements) {
        if (element.hasAttribute('rel')) {
          rel = element.getAttribute('rel') // Get existing attributes
          rel = rel.replace(/noopener/g, '').replace(/noreferrer/g, '').replace(/^\s+|\s+$/gm, '') // Remove noopener noreferrer and any whitespace
        }
        element.setAttribute('rel', 'noopener noreferrer' + (rel ? ' ' + rel : '')) // Add noopener noreferrer and any other existing attributes
      }
    },
    getBreakpoint () {
      var breakpoint
      if (window.getComputedStyle) {
        breakpoint = window.getComputedStyle(
          document.querySelector('body'), ':before'
        ).getPropertyValue('content')

        breakpoint = parseInt(breakpoint.replace("'", '').replace('"', ''))
      } else {
        breakpoint = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      }
      return breakpoint
    },
    loadAuthUrl () {
      return axios({
        url: `platforms/shopify/authorize/${this.$domain}`
      })
      .then((response) => {
        return response.data.authorization_url
      })
      .catch((error) => {
        console.log(error)
        return false
      })
    },
    loadUser () {
      if (process.env.DEFAULT_SHOP_DOMAIN) {
        let shop = {
          'id': 34959228973,
          'name': 'alt.View shop',
          'email': 'altview@thinkpivot.io',
          'domain': process.env.DEFAULT_SHOP_DOMAIN,
          'timezone': 'America/Los_Angeles',
          'currency_sign': '$',
          'myshopify_domain': process.env.DEFAULT_SHOP_DOMAIN,
          'complete_import': '2020-01-01',
          'initial_import': '2020-01-01',
          'active': true,
          'data': {}
        }
        setShopSettings(shop)
        this.$shop = shop
        if (!this.$domain) {
          setShopDomain(shop.domain)
          this.$domain = shop.domain
          window.location.href = window.location.pathname
        }
        return new Promise(resolve => { resolve({}) })
      }

      let profile = getProfile()

      return axios({
        url: `users/${profile.email}`,
        headers: { Authorization: `Bearer ${getAccessToken()}` }
      })
      .then((response) => {
        this.user = response.data

        let domain = getShopDomain()
        if (domain) {
          let shop = _find(this.user.shops, {'domain': domain})
          if (shop) {
            setShopSettings(shop)
            this.$shop = shop
          }
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    setState: function (name, value) {
      this.$data[name] = value
    },
    slideDown (el) {
      Velocity(el, 'slideDown', { duration: 'normal' })
    },
    slideToggle (className, e) {
      let self = e.currentTarget
      let parent = self.parentNode
      let target = parent.querySelector(className)
      let toggleMaxWidth = self.getAttribute('data-toggle-max-width')

      // Toggle if under toggle-max-width or no toggle-max-width set
      if ((toggleMaxWidth !== null && this.getBreakpoint() < toggleMaxWidth) || (toggleMaxWidth === null)) {
        if (parent.classList.contains('active-toggle')) {
          parent.classList.remove('active-toggle')
          Velocity(target, 'slideUp', { duration: 'normal' })
        } else {
          parent.classList.add('active-toggle')
          Velocity(target, 'slideDown', { duration: 'normal' })
        }

        e.preventDefault()
        e.stopPropagation()
      }
    },
    slideUp (el) {
      Velocity(el, 'slideUp', { duration: 'normal' })
    },
    tabs (e, parentClass) {
      let el = e.currentTarget
      let active = typeof (el.dataset.contentNavTab) !== 'undefined' ? el.dataset.contentNavTab : el.dataset.navTab
      let container = el.closest('[data-tabs]')
      let content = container.querySelector("[data-tab='" + active + "']")
      let contentActive = container.querySelector('.tab-content__item.active')
      let contentNavTab = container.querySelector("[data-content-nav-tab='" + active + "']")
      let contentNavTabActive = container.querySelector('.tab-content-nav.active')
      let navTab = container.querySelector("[data-nav-tab='" + active + "']")
      let navTabActive = container.querySelector('.tab-nav__item.active')

      // Content
      if (contentActive) {
        contentActive.classList.remove('active')
      }

      content.classList.add('active')

      // Nav content tab (Optional)
      if (typeof (contentNavTab) !== 'undefined') {
        if (contentNavTabActive) {
          contentNavTabActive.classList.remove('active')
        }

        contentNavTab.classList.add('active')

        if (this.getBreakpoint() < 768) {
          let activeTab = container.querySelector('.tab-content-nav.active')
          let activeTabTop = activeTab.getBoundingClientRect().top

          if (typeof (parentClass) !== 'undefined') { // Fixed parent
            let parent = el.closest(parentClass)
            let parentScrollDistance = parent.scrollTop
            let parentTop = parent.offsetTop + 15
            let position = (activeTabTop + parentScrollDistance) - parentTop

            parent.scrollTop = position
          } else {
            let body = document.body
            let rootElement = document.documentElement
            let style = body.currentStyle || window.getComputedStyle(body)
            let bodyTopPadding = parseInt(style.paddingTop) + 15

            rootElement.scrollTop = (activeTabTop + rootElement.scrollTop) - bodyTopPadding
          }
        }
      }

      // Nav tab
      if (navTabActive) {
        navTabActive.classList.remove('active')
      }

      navTab.classList.add('active')
    },
    toggleClass (className, transitionName, transitionDuration) {
      let element = document.querySelector('html')
      element.classList.toggle(className)

      if (transitionName && transitionDuration) {
        element.classList.add(transitionName)
        setTimeout(() => { element.classList.remove(transitionName) }, transitionDuration)
      }
    }
  },
  mounted () {
    this.fixTargetBlankAttacks()
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/globals.js